export function countImgsInLayout(data) {
    var count = 0;
    var countRecursively = function (initial) {
        if (typeof initial !== 'object' || initial === null) {
            return;
        }
        // eslint-disable-next-line
        Object.keys(initial).forEach(function (p) {
            var prop = p;
            if ({}.hasOwnProperty.call(initial, prop)) {
                if ((typeof initial[prop] === 'object' && prop === 'children') ||
                    prop === 'props') {
                    return Array.isArray(initial[prop])
                        ? initial[prop].map(countRecursively)
                        : countRecursively(initial[prop]);
                }
                if (typeof initial[prop] === 'object' && prop === 'props') {
                    return countRecursively(initial[prop]);
                }
                if (prop === 'type' && initial[prop] === 'img') {
                    count += 1;
                }
            }
        });
    };
    countRecursively(data);
    return count;
}
export function hasTagName(el, tagName) {
    var _a;
    return ((_a = el === null || el === void 0 ? void 0 : el.tagName) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === tagName;
}
